module.exports = __webpack_public_path__ + "img/platform-icon-2.074362fb.png";